import { ReactNode, createContext, useContext, useEffect, useState } from 'react';
import { getRequestsCount } from '../api/requests/requestsCount';
import useAuth from './useAuth';
import { Roles, Tokens } from '../constants';

interface State {
  activeRoutes: any,
  setActiveRoutes: (key: string, subKey: string) => void,
  preserveSelection: any,
  handleSelection: (val: any, key: string) => void,
  resetSelection: (val: any) => void
}

interface AuthProviderProps {
  children?: ReactNode;
}

const initialState: State = {
  activeRoutes: null,
  setActiveRoutes: (key: string, subKey: string) => { },
  preserveSelection: null,
  handleSelection: (val: any, key: string) => { },
  resetSelection: (val: any) => {}
};

const ActiveRoutesContext = createContext<State>({
  ...initialState
});

export const ActiveRoutesProvider: React.FC<AuthProviderProps> = (props) => {
  const { children } = props;
  const { userRole, clientId } = useAuth();
  const [activeRoutes, setActiveRoutes] = useState<any>();
  const [preserveSelection, setPreserveSelection] = useState<any>();

  const getRequestsCountApi = async () => {
    const details = localStorage.getItem(Tokens.accessToken) && await getRequestsCount();
    if (details?.data) {
      setActiveRoutes(details?.data);
    }
  };

  const handleActiveRoutes = (key: string, subKey: string) => {
    if (activeRoutes?.[key]) {
      const data = {
        ...activeRoutes,
        [key]: {
          ...activeRoutes[key],
          [subKey]: 0
        }
      };
      setActiveRoutes(data);
    }
  };

  const handleSelection = (val: any, key: string) => {
    let data = {
      ...(preserveSelection ?? {})
    };
    if (data?.[key]) {
      data[key] = val;
    } else {
      data = {
        ...data,
        [key]: val
      };
    }
    setPreserveSelection(data);
  };

  useEffect(() => {
    (userRole !== Roles.USER) && getRequestsCountApi();
    (userRole === Roles.USER) && setActiveRoutes(null);
    setPreserveSelection(null);
  }, [clientId]);

  return (
    <ActiveRoutesContext.Provider
      value={{
        activeRoutes,
        setActiveRoutes: handleActiveRoutes,
        preserveSelection,
        handleSelection,
        resetSelection: setPreserveSelection
      }}
    >
      {children}
    </ActiveRoutesContext.Provider>
  );
};

export const useActiveRoutes = () => useContext(ActiveRoutesContext);
